import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import myPoints from './views/my-points'

export default [
  {
    path: RoutePathConstants.MY_POINTS,
    name: 'myPoints',
    component: myPoints
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-points/routers.js